export const OPENTABLE_ERROR_PAGE_UI_COPY = {
  errorMessage:
    "Thanks for signing up for a PolyAI Account. \nTo continue you'll need a workspace.",
  contactMessage: 'Contact our team for assistance.',
  contactToastTitle: 'Email copied to clipboard',
  contactToastMessage:
    "We've copied our support email to your clipboard. Get in touch to discuss your next steps with PolyAI.",
  contactEmail: 'restaurantsupport@poly-ai.com',
} as const;
